import Router from 'next/router';
import { useEffect } from 'react';

import { useIsCurrentUserEmailVerified } from '~/swr-hooks/account/useIsCurrentUserEmailVerified';
import { redirectToVerifyUser } from '~/utils/auth/authResumeRedirect';

export const useRedirectUnverifiedUser = () => {
  const { isFetched, userEmailIsVerified } = useIsCurrentUserEmailVerified();

  useEffect(() => {
    if (isFetched && userEmailIsVerified === false) {
      Router.ready(() => {
        // Preserve the current path (e.g. /home?skipOnboarding=…) so post-verify
        // resume can continue partner deep-link / skip-onboarding flows — including
        // `/verify/…` which has no redirect query of its own.
        void redirectToVerifyUser({ router: Router, redirectTarget: Router.asPath });
      });
    }
  }, [isFetched, userEmailIsVerified]);
};
